import { Switch } from "antd";
import { useSwitch } from "../../Contexts/SwitchContext";

const SwitchToggle = () => {
    const { switchValue, setSwitchValue } = useSwitch();

    return <Switch
        checked={switchValue}
        onChange={(checked) => setSwitchValue(checked)}
    />;
};

export default SwitchToggle;